import api from '../lib/api';
import type { ApiResponse, LoginResponse, AuthUser } from '@maios/shared';

export async function login(email: string, password: string): Promise<LoginResponse> {
  const res = await api.post<ApiResponse<LoginResponse>>('/v1/auth/login', { email, password });
  return res.data.data!;
}

export async function getMe(): Promise<AuthUser> {
  const res = await api.get<ApiResponse<AuthUser>>('/v1/auth/me');
  return res.data.data!;
}

export async function logout(refreshToken: string): Promise<void> {
  await api.post('/v1/auth/logout', { refreshToken });
}

export async function refreshTokens(
  refreshToken: string,
  accessToken: string,
): Promise<{ accessToken: string; refreshToken: string }> {
  const res = await api.post<ApiResponse<{ accessToken: string; refreshToken: string }>>(
    '/v1/auth/refresh',
    { refreshToken },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return res.data.data!;
}

// ── CHG-070-P3: 2FA (TOTP) ──

export interface TotpLoginResponse {
  requireTotp?: boolean;
  tempToken?: string;
  user?: { id: string; email: string; name: string; role: string };
  tokens?: { accessToken: string; refreshToken: string };
}

export async function totpAuthenticate(params: { tempToken: string; totpToken: string }): Promise<LoginResponse> {
  const res = await api.post<ApiResponse<LoginResponse>>('/v1/auth/totp/authenticate', params);
  return res.data.data!;
}

export interface TotpSetupData {
  secret: string;
  qrCodeUrl: string;
  qrCodeDataUrl: string;
}

export async function totpSetup(): Promise<TotpSetupData> {
  const res = await api.post<ApiResponse<TotpSetupData>>('/admin/auth/totp/setup');
  return res.data.data!;
}

export async function totpVerifySetup(token: string): Promise<{ backupCodes: string[] }> {
  const res = await api.post<ApiResponse<{ backupCodes: string[] }>>('/admin/auth/totp/verify-setup', { token });
  return res.data.data!;
}

export async function totpDisable(token: string): Promise<void> {
  await api.delete('/admin/auth/totp', { data: { token } });
}
